precision highp float;

uniform float time;
varying float vAlpha;
uniform float progress;
varying float vRandom;

float hash(vec2 p) { return fract(sin(dot(p, vec2(127.1,311.7))) * 43758.5453123); }

float noise(vec2 p){
  vec2 i = floor(p); vec2 f = fract(p);
  float a = hash(i); float b = hash(i + vec2(1.0, 0.0));
  float c = hash(i + vec2(0.0, 1.0)); float d = hash(i + vec2(1.0, 1.0));
  vec2 u = f * f * (3.0 - 2.0 * f);
  return mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}

float getDigitMask(vec2 p, float isOne) {
    vec2 pAbs = abs(p);
    float oneMask  = step(pAbs.x, 0.04) * step(pAbs.y, 0.35);
    float outer    = step(pAbs.x, 0.15) * step(pAbs.y, 0.3);
    float inner    = step(pAbs.x, 0.07) * step(pAbs.y, 0.2);
    float zeroMask = max(0.0, outer - inner);
    return mix(zeroMask, oneMask, isOne);
}

void main() {
  vec2 uv = gl_PointCoord.xy - 0.5;

  float isOne = step(0.5, vRandom);
  float charMask = getDigitMask(uv, isOne);

  if (charMask < 0.1) discard;

  vec2 ncoord = uv * 4.0;
  float n = noise(ncoord + vec2(time * 0.1 + vRandom * 5.0, time * 0.05));

  vec3 dark = vec3(0.02, 0.20, 0.08);
  vec3 light = vec3(0.15, 1.00, 0.45);

  float t = clamp(vRandom * 0.8 + 0.2, 0.0, 1.0);
  vec3 baseCol = mix(dark, light, t);

  baseCol *= (0.95 + 0.10 * n);

  float finalAlpha = charMask * progress * vAlpha;

  gl_FragColor = vec4(baseCol, finalAlpha);
}